module.exports = __webpack_public_path__ + "img/logo.f3332361.png";